<template>
  <div class="py-5 md:px-5">
    <PageHeader class="container" title="Booking Forms">
      <router-link :to="{ name: 'BookingFormCreate' }" class="btn btn-primary">
        Add Form
      </router-link>
    </PageHeader>

    <div class="container">
      <hr class="mb-6">
      <!-- Loading -->
      <Loading v-if="loading" class="p-6" />
      <!-- List -->
      <div v-else>
        <!-- No Results -->
        <div v-if="forms.meta.total < 1" class="max-w-sm py-12 mx-auto text-center">
          <div class="mb-2 text-lg font-bold">
            You don't have any booking forms yet.
          </div>
          <div class="text-gray-500">
            Booking forms allow you to capture bookings directly from customers which you can then approve to become orders.
          </div>
          <router-link :to="{ name: 'BookingFormCreate' }" class="mt-4 btn btn-outline">
            Create Your First Booking Form
          </router-link>
        </div>

        <div v-else>
          <ul class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            <li class="col-span-1 bg-white divide-y divide-gray-200 rounded-lg shadow" v-for="form in forms.data" :key="form.id">
              <div class="flex items-center justify-between w-full p-6 space-x-6">
                <div class="flex-1 leading-tight truncate">
                  <div class="flex items-center space-x-3">
                    <h3 class="font-medium text-gray-900 truncate ">{{ form.name }}</h3>
                  </div>
                  <p class="mt-1 text-gray-500 truncate">{{ parseFormType(form.type) || '-' }}</p>
                </div>
                <div class="grid w-10 h-10 text-gray-500 bg-gray-100 rounded-md place-items-center">
                  <fa :icon="['far', 'route']" v-if="form.type === 'transport'" />
                  <fa :icon="['far', 'box-up']" v-else-if="form.type === 'pickup'" />
                  <fa :icon="['far', 'parachute-box']" v-else-if="form.type === 'delivery'" />
                  <fa :icon="['far', 'concierge-bell']" v-else-if="form.type === 'service'" />
                </div>
              </div>
              <div>
                <div class="flex -mt-px divide-x divide-gray-200">
                  <div class="flex flex-1 w-0">
                    <router-link :to="{ name: 'BookingFormEdit', params: { id: form.id } }" class="relative inline-flex items-center justify-center flex-1 w-0 py-4 font-medium text-gray-700 border border-transparent rounded-b-lg rounded-bl-lg hover:no-underline hover:bg-gray-50 hover:bg-opacity-25">
                      <fa :icon="['far', 'edit']" class="opacity-75 texgt-xl" />
                      <span class="ml-2">Edit</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- Pagination -->
        <Pagination class="pt-8 mt-8 border-t" transparent :total="forms.meta.total" :per-page="forms.meta.per_page" :current-page="forms.meta.current_page" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookingFormList',

  metaInfo: {
    title: 'Booking Forms'
  },

  created () {
    this.getForms()
  },

  data () {
    return {
      loading: true,
      forms: {}
    }
  },

  methods: {
    async getForms () {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/booking-forms`, {
          params: {
            page: this.$route.query.page || 1
          }
        })
        this.forms = data.forms
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    parseFormType (type) {
      let map = {
        'service': `Service`,
        'pickup': `Pickup`,
        'delivery': `Delivery`,
        'transport': `Transport`
      }
      return map[type]
    }
  },

  watch: {
    '$route.query': {
      handler (newVal, oldVal) {
        this.getForms()
      },
      deep: true
    }
  }
}
</script>